const currentYearEl = document.getElementById('current-year');
if (currentYearEl) {
    currentYearEl.textContent = String(new Date().getFullYear());
}
